import { Component, HostBinding, Input, OnChanges } from '@angular/core';

@Component({
    selector: 'app-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
    standalone: false
})
export class IconComponent implements OnChanges {
  @Input() size: 'sm' | 'md' | 'lg' = 'md';

  @Input()
  get name(): string {
    return this._name;
  }
  set name(name: string) {
    this._name = name ? `url(assets/icons/${name && name.trim()}.svg)` : '';
  }

  @HostBinding('style.mask-image') public _maskImg: string;
  @HostBinding('style.-webkit-mask-image') public _maskImgWebKit: string;
  @HostBinding('class.md') public _size: 'sm' | 'md' | 'lg' = 'md';

  private _name = '';

  constructor() {}

  ngOnChanges() {
    this._size = this.size;
    this._maskImg = this.name;
    this._maskImgWebKit = this.name;
  }
}
